export default function nlDate(mongoDate) {
    const justDate = mongoDate.split('T');
    const dateParts = justDate[0].split('-');
    const nlBookingDate = dateParts[2] + '-' + dateParts[1] + '-' + dateParts[0];
    return nlBookingDate
}